// @ts-check
import { ref, computed, toRef } from 'vue'

/**
 * 제어/비제어 상태를 통합 관리하는 Composable.
 * `v-model`과 유사한 로직을 쉽게 구현할 수 있도록 도와줍니다.
 * @template T
 * @param {Record<string, any>} props - 컴포넌트의 `props` 객체.
 * @param {string} key - `props`에서 제어할 속성명(e.g., 'modelValue').
 * @param {object} [options] - 추가 옵션.
 * @param {(eventName: string, ...args: any[]) => void} [options.emit] - `update:KEY` 이벤트를 발생시키는 emit 함수.
 * @param {T} [options.defaultValue] - 비제어 상태에서 사용할 기본값
 * @returns {import('vue').WritableComputedRef<T>}
 */
export function useControllable(props, key, options = {}) {
  const { emit, defaultValue } = options
  const propValue = toRef(props, key)
  const isControlled = computed(() => propValue.value !== undefined)

  const internalState = ref(defaultValue)

  return computed({
    get() {
      return isControlled.value ? /** @type {T} */ (propValue.value) : internalState.value
    },
    set(newValue) {
      // 제어 모드이고 emit 함수가 제공되었다면 이벤트를 발생시킵니다.
      if (isControlled.value && emit) {
        emit(`update:${key}`, newValue)
      }
      // 비제어 모드일 때는 내부 상태만 업데이트합니다.
      internalState.value = newValue
    }
  })
}













